import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";
import { generateId } from "./utils";

export const toggleWorkflowFavorite = mutator({
  schema: z.object({
    workflowId: z.string(),
  }),
  resolve: {
    workflow: { kind: "workflow", from: "workflowId" },
  },
  permissions: [
    {
      permission: "space:read",
      scopeId: ({ args }) => args.workflow.spaceId,
    },
  ],
  fn: async ({ tx, ctx, args: { workflow } }) => {
    const { userId } = ctx;
    const existing = await tx.run(
      zql.workflowFavorites
        .where("userId", userId)
        .where("workflowId", workflow.id)
        .one()
    );

    if (existing) {
      await tx.mutate.workflowFavorites.delete({ id: existing.id });
    } else {
      await tx.mutate.workflowFavorites.insert({
        id: generateId(),
        userId,
        workflowId: workflow.id,
        createdAt: Date.now(),
        tenantId: ctx.tenantId,
      });
    }
  },
});
